import {
  CreateRiskDynamicFieldInput,
  RiskDynamicField as RiskDynamicFieldRow,
  RiskDynamicFieldTypeEnum,
} from 'app/API.service';

export class RiskRegisterConstants {
  // impact + ' ' + probability
  public static lowLabelRange: string[] = ['low low', 'low medium', 'low high', 'medium low'];

  public static mediumLabelRange: string[] = ['low critical', 'medium medium', 'medium high', 'high low'];

  public static highLabelRange: string[] = ['medium critical', 'high medium', 'critical low', 'critical medium'];

  public static criticalLabelRange: string[] = ['high critical', 'high high', 'critical high', 'critical critical'];

  public static popUpsStrings = {
    DISABLE: 'disable',
    DELETE: 'delete',
    ARCHIVE: 'archive',
    ESCALATE: 'escalate',
    DE_ESCALATE: 'deescalate',
    RE_ACTIVATE: 'reactivate',
    SAVE_FILTER: 'filter',
  };

  public static filterNameToObject = {
    status: 'riskStatus',
    impact: 'riskImpact',
    probability: 'riskProbability',
    inherentImpact: 'riskImpact',
    inherentProbability: 'riskProbability',
    residualProbability: 'residualProbability',
    residualImpact: 'residualImpact',
    show: 'disable',
    priority: 'riskPriority',
    source: 'type',
    residual: 'residualRisk',
    entities: 'subEntityId',
    tags: 'riskTags',
    financial: 'financialToggle',
    tasks: 'riskTasks',
    escalated: 'isEscalated',
    riskOwner: 'riskOwnerIds',
    assets: 'relatedAssets',
  };
  public static financialToggle = {
    With: true,
    Without: false,
  };
}

export class RiskTableConstant {
  public static SORT_TYPE: any = {
    ASC: 'asc',
    DSC: 'dsc',
    NA: 'na',
  };
  public static ASSET_ITEMS: any = {
    SOFTWARE: 'Software',
    INFORMATION: 'Information',
    HARDWARE: 'Hardware',
    NETWORK: 'Network',
    PEOPLE: 'People',
    FACILITIES: 'Facilities',
  };
  public static EDITABLE_SECTIONS: any = {
    'Related Assets': true,
    Impact: true,
    Probability: true,
    Controls: false,
    'Financial Impact': true,
    'Cost To Remediate': true,
    Description: true,
    Notes: true,
    ID: false,
    Name: true,
    Entity: false,
    Priority: true,
    Inherent: false,
    Residual: false,
    Status: true,
    Tagging: true,
    Tasks: false,
    'Open Remediation Tasks': true,
  };
  public static INFO_DATA: any = {
    ID: 'idTitle',
    Name: 'riskTitle',
    Entity: 'subEntity',
    Inherent: 'inherentRisk',
    Residual: 'residualRisk',
    Financial: 'primaryLoss',
    Status: 'riskStatus',
  };
  public static GROUP_INFO_DATA: any = {
    ID: 'idTitle',
    Name: 'riskTitle',
    Inherent: 'inherentRisk',
    Residual: 'residualRisk',
    Financial: 'primaryLoss',
    Status: 'riskStatus',
  };
  public static INFO_DATA_DETAILS: any = {
    relatedAssets: 'relatedAssets',
    riskImpact: 'riskImpact',
    riskProbability: 'riskProbability',
    residualImpact: 'residualImpact',
    residualProbability: 'residualProbability',
    Control_List: 'controlIds',
    'Financial Impact': 'financialImpact',
    'Cost To Remediate': 'costToRemediate',
    'Risk Owner': 'riskOwner',
    Sensitivity: 'sensitivity',
    'Control Effectiveness': 'controlEffectiveness',
    Description: 'riskDescription',
    Notes: 'notes',
    riskTags: 'riskTags',
    Tasks: 'riskTasks',
    'Financial Exposure': 'FinancialExposure',
  };
  public static RISK_TYPE_SVG: any = {
    AUTOMATIC: 'risk-auto-icon',
    MANUAL: 'risk-semi-auto-icon',
    HARD_MANUAL: 'risk-manual-icon',
    AI: 'risk-ai-icon',
    GROUP: 'risk-group-icon',
  };
  public static RISK_TYPE_TOOLTIP: any = {
    AUTONOMOUS: 'Source: Autonomous',
    AUTOMATIC: 'Source: Autonomous',
    MANUAL: 'Source: Automatic',
    HARD_MANUAL: 'Source: Manual',
    AI: 'Source: AI',
  };
  public static GROUP_TYPE_TOOLTIP: any = {
    AUTOMATIC: 'Source: Risk Group, Autonomous',
    MANUAL: 'Source: Risk Group Manual',
  };
}

export class RiskFinancialConstant {
  public static MODE: any = {
    PML: 'pml',
    BASIC: 'basic',
    ADVANCED: 'advanced',
    ALL: 'all',
  };
}

export enum RISK_RESIDUAL_SCORE_ENUM {
  NA = 999,
  NO = 0,
}

export enum RISK_REGISTER_ENTITY_FILTER_ENUM {
  RISK_GROUP = '2',
  ALL_RISK = '1',
}

export enum RiskActionType {
  RISK_UPDATE = 'updated',
  RISK_DELETE = 'deleted',
  RISK_ARCHIVE = 'archived',
  RISK_REACTIVATE = 'reactivated',
  RISK_ESCALATE = 'escalated',
  RISK_DEESCALATE = 'deescalated',
  RISK_DISABLE = 'disabled',
  RISK_ENABLE = 'enabled',
  RISK_CREATE = 'created',
}
//* Risk Residual Floor for Residual Risk Calculation
export const RISK_RESIDUAL_FLOOR = 0.25;

//* EXPORT ENUMS
export enum RISK_EXPORT_OPTIONS {
  EXPORT_XLS = 'General Report (XLS)',
  EXPORT_CSV = 'General Report (CSV)',
  EXPORT_CURRENT_XLS = 'Current View (XLS)',
  EXPORT_CURRENT_CSV = 'Current View (CSV)',
  EXPORT_RISK_GROUP_XLS = 'Risk Group (XLS)',
  EXPORT_RISK_GROUP_CSV = 'Risk Group (CSV)',
}

export { RiskDynamicFieldTypeEnum };

export const RISK_DYNAMIC_FIELD_TYPE_OPTIONS: RiskDynamicFieldOption[] = [
  { id: RiskDynamicFieldTypeEnum.TEXT, name: 'Text' },
  { id: RiskDynamicFieldTypeEnum.TEXTAREA, name: 'Long text' },
  { id: RiskDynamicFieldTypeEnum.NUMBER, name: 'Number' },
  { id: RiskDynamicFieldTypeEnum.CURRENCY, name: 'Currency' },
  { id: RiskDynamicFieldTypeEnum.DATE, name: 'Date' },
  { id: RiskDynamicFieldTypeEnum.SELECT, name: 'Dropdown (single-select)' },
  { id: RiskDynamicFieldTypeEnum.MULTI_SELECT, name: 'Multi-select' },
  { id: RiskDynamicFieldTypeEnum.BOOLEAN, name: 'Yes / No' },
];

export const RISK_DYNAMIC_FIELD_CURRENCIES: RiskDynamicFieldOption[] = [
  { id: 'USD', name: 'USD  ($)' },
  { id: 'EUR', name: 'EUR  (€)' },
  { id: 'GBP', name: 'GBP  (£)' },
  { id: 'ILS', name: 'ILS  (₪)' },
];

export const RISK_DYNAMIC_FIELD_OPTION_TYPES: RiskDynamicFieldTypeEnum[] = [
  RiskDynamicFieldTypeEnum.SELECT,
  RiskDynamicFieldTypeEnum.MULTI_SELECT,
];

/**
 * One `SELECT` choice. Shaped as an object with `id` because the shared
 * `cygov-custom-drop-down` matches selections on `item.id` and renders
 * `bindLabel` — it does not accept a plain string list.
 */
export interface RiskDynamicFieldOption {
  id: string;
  name: string;
}

export interface RiskDynamicField {
  key: string;
  label: string;
  type: RiskDynamicFieldTypeEnum;
  required: boolean;
  /** Options for `SELECT` and `MULTI_SELECT` fields only. */
  options?: RiskDynamicFieldOption[];
  currency?: string;
  order?: number;
  isArchived?: boolean;
}

export interface RiskDynamicFieldMetadata {
  required?: boolean;
  order?: number;
  options?: RiskDynamicFieldOption[];
  currency?: string;
}

export function parseRiskDynamicFieldMetadata(metadata: string): RiskDynamicFieldMetadata {
  if (!metadata) {
    return {};
  }
  try {
    const parsed = JSON.parse(metadata);
    return parsed && typeof parsed === 'object' ? parsed : {};
  } catch {
    return {};
  }
}

export interface RiskDynamicFieldValues {
  [fieldId: string]: any;
}

export function buildRiskDynamicFieldValueId(riskId: string, fieldId: string): string {
  return `${riskId}#${fieldId}`;
}

/** Shown when a required dynamic field is unanswered, in every creation mode. */
export const RISK_DYNAMIC_FIELD_REQUIRED_MESSAGE = 'Please fill the required fields';

export function findMissingRequiredDynamicField(
  fields: RiskDynamicField[],
  values: RiskDynamicFieldValues
): RiskDynamicField {
  return (fields || []).find(field => field.required && !hasRiskDynamicFieldValue(values?.[field.key])) || null;
}

/** True when the value is worth storing a row for. */
export function hasRiskDynamicFieldValue(value: any): boolean {
  if (value === null || value === undefined || value === '') {
    return false;
  }
  return Array.isArray(value) ? value.length > 0 : true;
}

export function toRiskDynamicFieldValueInput(
  riskId: string,
  fieldId: string,
  value: any,
  entityId?: string
): CreateRiskDynamicFieldInput {
  return {
    id: buildRiskDynamicFieldValueId(riskId, fieldId),
    entityId,
    parentId: fieldId,
    riskId,
    value: JSON.stringify(value ?? null),
  };
}

export function toRiskDynamicFieldValues(rows: RiskDynamicFieldRow[]): RiskDynamicFieldValues {
  const values: RiskDynamicFieldValues = {};
  (rows || []).forEach(row => {
    if (!row?.parentId) {
      return;
    }
    values[row.parentId] = parseRiskDynamicFieldValue(row.value);
  });
  return values;
}

export function parseRiskDynamicFieldValue(value: string): any {
  if (value === null || value === undefined || value === '') {
    return null;
  }
  try {
    return JSON.parse(value);
  } catch {
    // Pre-JSON rows, or anything hand-edited in the console, read as plain text.
    return value;
  }
}

/** Flattens a persisted row plus its metadata into the shape components use. */
export function toRiskDynamicField(row: RiskDynamicFieldRow): RiskDynamicField {
  const metadata = parseRiskDynamicFieldMetadata(row?.metadata);
  return {
    key: row.id,
    label: row.name,
    type: row.type,
    required: !!metadata.required,
    options: metadata.options || [],
    currency: metadata.currency || null,
    order: typeof metadata.order === 'number' ? metadata.order : 0,
    isArchived: !!row?.isArchived,
  };
}

export function toRiskDynamicFieldInput(field: RiskDynamicField, entityId: string): CreateRiskDynamicFieldInput {
  const metadata: RiskDynamicFieldMetadata = {
    required: !!field.required,
    order: typeof field.order === 'number' ? field.order : 0,
  };
  if (RISK_DYNAMIC_FIELD_OPTION_TYPES.indexOf(field.type) > -1) {
    metadata.options = field.options || [];
  }
  if (field.type === RiskDynamicFieldTypeEnum.CURRENCY) {
    metadata.currency = field.currency;
  }
  return {
    name: field.label,
    entityId,
    type: field.type,
    metadata: JSON.stringify(metadata),
    isArchived: !!field.isArchived,
  };
}
